import { Anchor, Badge, Button, Paper, Stack, Text } from "@mantine/core"
import { useEffect, useState } from "react"
import { apiFetch } from "atlas_forecasting_app/lib/api_fetch"
import { formatDateTime } from "atlas_forecasting_app/lib/format"
import { RouterLink } from "atlas_forecasting_app/lib/router"
import { EmptyState, ErrorAlert, LoadingState, PageHeader } from "atlas_forecasting_app/components/common/page_elements"

export function DraftQuestionsPage() {
  const [items, setItems] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState("")

  useEffect(() => {
    let mounted = true

    apiFetch("/api/question_drafts")
      .then((data) => {
        if (!mounted) return
        setItems(data.items || [])
        setError("")
      })
      .catch((e) => {
        if (!mounted) return
        setError(e.message)
      })
      .finally(() => {
        if (!mounted) return
        setLoading(false)
      })

    return () => {
      mounted = false
    }
  }, [])

  return (
    <Stack gap="lg">
      <PageHeader
        eyebrow="Workspace"
        variant="editorial"
        title="Draft questions"
        subtitle="Questions you started but have not confirmed yet."
        action={
          <Button component={RouterLink} to="/my-questions" variant="light">
            My Questions
          </Button>
        }
      />

      <ErrorAlert message={error} />
      {loading ? <LoadingState label="Loading draft questions..." /> : null}

      {!loading && !error && items.length === 0 ? (
        <EmptyState
          title="No draft questions yet"
          message="Start a new question and the in-progress draft will appear here until you confirm it."
          action={
            <Button component={RouterLink} to="/new-question">
              Start a draft
            </Button>
          }
        />
      ) : null}

      <Stack gap="md" className="af-card-list">
        {items.map((item) => {
          const meta = item.updated_at ? `Last updated ${formatDateTime(item.updated_at)}` : ""

          return (
            <Paper key={item.id} withBorder radius="xl" shadow="xs" p="lg" className="af-draft-card">
              <Stack gap="sm">
                <Stack gap={4}>
                  <Text className="af-draft-card__eyebrow">Draft</Text>
                  {item.first_user_message ? (
                    <Anchor component={RouterLink} to={`/draft-questions/${item.id}`} fw={700} underline="never" className="af-draft-card__title" style={{ whiteSpace: "pre-wrap" }}>
                      {item.first_user_message}
                    </Anchor>
                  ) : null}
                  {meta ? (
                    <Text size="sm" className="af-draft-card__meta">
                      {meta}
                    </Text>
                  ) : null}
                </Stack>
                <Badge variant="light" color="blue" w="fit-content" size="lg">
                  {item.state || "draft"}
                </Badge>
              </Stack>
            </Paper>
          )
        })}
      </Stack>
    </Stack>
  )
}
